var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formButtonSubmit"},[_c('button',_vm._g(_vm._b({staticClass:"loginbtn primaryBtn",attrs:{"type":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n   "+_vm._s(_vm.buttonText)+"\n   ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }